import React from "react";
import "./Home.css";
import HomeImg from "./HomeImg";
import HomeSection from "./HomeSection";

import About2 from "./About2";
import Product from "./Product";

const Home = () => {
  return (
    <div className="home_main">
      <HomeImg />
      <HomeSection />

      <About2 />
      <Product />
    </div>
  );
};

export default Home;
